import { ReactNode } from "react";
import { useSamplesAirMicrobialBaseDataListQuery } from "@/services/backend/samples/api/air-microbial-base-data-api";
import { airMicrobialBaseDataKey } from "@/services/backend/samples/types/sample-base-data";
import {
  SampleBaseDataListRequest,
  SampleBaseDataTable,
  useSampleBaseDataListRequestWithCompanies,
} from "@/services/backend/samples/components/sample-base-data-table";
import { DeleteAirMicrobialBaseDataDialog } from "@/services/backend/samples/components/delete-air-microbial-base-data-dialog";

export function AirMicrobialBaseDataTable({
  request,
  onRequestChange,
  renderRowLink,
  hidePagination,
  hideBorder,
}: {
  request: SampleBaseDataListRequest;
  onRequestChange: (request: SampleBaseDataListRequest) => void;
  renderRowLink: (baseDataId: string, children: ReactNode) => ReactNode;
  hidePagination?: boolean;
  hideBorder?: boolean;
}) {
  const { request: effectiveRequest, skip } =
    useSampleBaseDataListRequestWithCompanies(request);
  const { data, isLoading, error } = useSamplesAirMicrobialBaseDataListQuery(
    effectiveRequest,
    { skip },
  );

  return (
    <SampleBaseDataTable
      data={data}
      isLoading={isLoading}
      error={error}
      dataKey={airMicrobialBaseDataKey}
      request={request}
      onRequestChange={onRequestChange}
      renderRowLink={renderRowLink}
      renderDeleteAction={(baseData) => (
        <DeleteAirMicrobialBaseDataDialog baseData={baseData} />
      )}
      hidePagination={hidePagination}
      hideBorder={hideBorder}
    />
  );
}
